import React from 'react'
import Page from '../Page'
import * as rdd from 'react-device-detect';
import './aboutUs.css'

import data from './aboutus.json'

export default class Index extends Page {
   constructor(props){
      super(props)
      this.state = {
         data
      }
   }

   componentDidMount(){
      let element = document.querySelector('.loading');
      if (element) {
         element.style.display = 'none';
       }
   }
  render() {
   const {data} = this.state
    return (
      <div>
         {
            data.map((item,index) => {
               return(
                  <div
                     className={`container-${item.part}-about`}
                     key={index}
                  >  
                     {
                        item.part === 'content' && (
                           <div className='ornament-content'>
                              <img
                                 src={item.ornament}
                                 style={{
                                    width: item.title === 'Visi' ? rdd.isMobile ? '95px' : '120px' : rdd.isMobile ? '130px' : '180px',
                                    position:'absolute',
                                    top:'10%',
                                    left: item.title === 'Visi' ? '5%' : '1%'
                                 }}
                              />
                           </div>
                        )
                     }
                     <div className='content'>
                        <div className={item.part == 'content' ? 'start-about' : ''}>
                           <div>
                              {
                                 item.part == 'introduction' && (
                                    <img 
                                       src='/img/ornament/Ornament-About-04.png' 
                                       style={{
                                          width:'50px',
                                       }}
                                    />
                                 )
                              }
                              {
                                 item.title == 'Visi' ? (
                                    <div>
                                    </div>
                                 ) : item.title == 'Misi' ? (
                                    <div>
                                       <img 
                                          src='/img/ornament/Ornament-About-11.png'
                                          style={{
                                             position:'absolute',
                                             right:'0%',
                                             top: '-90%',
                                             width: rdd.isMobile ? '45px' : '80px'
                                          }}
                                       />
                                    </div>
                                 ) : null
                              }
                              <div 
                                 className={`title-${item.part}-style`}
                                 style={{
                                    backgroundColor: item.title == 'Visi' ? '#39B54A' : item.title == 'Misi' ? '#A3D65C' : ''
                                 }}
                              >
                                 <h4 
                                    style={{
                                       color: 'white', 
                                       marginBottom:0,
                                    }}
                                    dangerouslySetInnerHTML={{__html: item.part === 'introduction' || item.part === 'reason' ? rdd.isMobile ? item.titleMobile : item.titleWeb : item.title}}
                                 />
                              </div>
                              <h6 
                                 style={{
                                    color: item.part == 'introduction' ? 'white' : '#9cbf3f' ,
                                    lineHeight:'1.7em', 
                                    maxWidth:'700'
                                 }} 
                                 dangerouslySetInnerHTML={{
                                    __html: item.description
                                 }} 
                              />
                              {
                                 item.part == 'reason' && (
                                    <div className='reason-about' style={{position:'relative', zIndex:2, paddingBottom: '40px'}}>
                                       <ul style={{margin:'0px', paddingInlineStart:'0px'}}>
                                       {
                                          item.subContentHeader.map((data,index) => (
                                             <li 
                                                key={index}
                                                style={{
                                                   display:'flex',
                                                   alignItems:'center',
                                                   backgroundColor:'#648B25',
                                                   padding: '10px',
                                                   borderRadius: '20px',
                                                   overflowX:'hidden'
                                                }}
                                             >
                                                <img
                                                   src={data.ornament}
                                                   style={{width: '50px', height:'50px'}}
                                                />
                                                <div>
                                                   <h6 style={{color:'white', fontSize: rdd.isMobile ? '10px':''}} dangerouslySetInnerHTML={{__html: data.title}} />
                                                   <h6 style={{lineHeight:'1.6em', maxWidth:'700', color:'white', fontSize: rdd.isMobile ? '6px':''}} dangerouslySetInnerHTML={{__html: data.description}} />
                                                </div>
                                             </li>
                                          ))
                                       }
                                       </ul>
                                       <img 
                                          src='/img/ornament/Ornament-About-17.webp'
                                          style={{
                                             width: rdd.isMobile ? '185px' : '300px',
                                             position:'absolute',
                                             top: rdd.isMobile ? '-38%' : '-48%',
                                             left: rdd.isMobile ? '-12%' : '-11%',
                                             zIndex: '-1'
                                          }}
                                       />
                                       <img 
                                          src='/img/ornament/Banner-09.png'
                                          style={{
                                             width: rdd.isMobile ? '70px' :'100px',
                                             position:'absolute',
                                             top: rdd.isMobile ? '-20%' : '-20%',
                                             right:'0',
                                             zIndex: '-1'
                                          }}
                                       />
                                       <img 
                                          src='/img/ornament/Ornament-About-16.png' 
                                          className={rdd.isMobile ? 'ornament-16-reason-mobile' : 'ornament-16-reason-web'}
                                       />
                                       <img 
                                          src='/img/ornament/Ornament-About-07.png' 
                                          className={rdd.isMobile ? 'ornament-07-reason-mobile' : 'ornament-07-reason-web'}
                                       />
                                    </div>
                                 )
                              }
                              {
                                 item.part == 'introduction' && (
                                    <div>
                                       <img 
                                          src='/img/ornament/Ornament-About-05.png' 
                                          className={rdd.isMobile ? 'ornament-05-mobile' : 'ornament-05-web'}
                                          />
                                       <img 
                                          src='/img/ornament/Ornament-About-06.png' 
                                          className={rdd.isMobile ? 'ornament-06-mobile' : 'ornament-06-web'}
                                       />
                                       <img 
                                          src='/img/ornament/Ornament-About-16.png' 
                                          className={rdd.isMobile ? 'ornament-16-intro-mobile' : "ornament-16-intro-web" }
                                       />
                                       <img 
                                          src='/img/ornament/Ornament-About-07.png' 
                                          className={rdd.isMobile ? 'ornament-07-intro-mobile' : `ornament-07-intro-web`}
                                       />
                                    </div>
                                 )
                              }
                           </div>
                        </div>
                        {
                           item.part == 'content' && (
                              item.subContentHeader.length > 0 ? (
                                 <div className='center-about'>
                                    <ol className='about-list'>
                                       {
                                          item.subContentHeader.map((data,index) => (
                                             <li className='about-list-item' key={index}>
                                                <h6 style={{color:'#9cbf3f'}} dangerouslySetInnerHTML={{__html: data.title}} />
                                                <h6 style={{lineHeight:'1.6em', maxWidth:'700', color:'#9cbf3f', margin:0, fontSize: rdd.isMobile ? '11px' : '1rem'}} dangerouslySetInnerHTML={{__html: data.description}} />
                                             </li>
                                          ))
                                       }
                                    </ol>
                                 </div>
                              ):null
                           )
                        }
                     </div>
                  </div>
               )
            })
         }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/About/Index.js